import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { CreatorsService } from '@pages/creators/creators.service';
import { IStats } from '@shared/interfaces/stats.interface';
import { EMPTY, MonoTypeOperatorFunction, Observable, pipe } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

interface ICreatorsKpiCardsState {
  stats: IStats[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: ICreatorsKpiCardsState = {
  error: null,
  loading: false,
  stats: null,
};

@Injectable()
export class CreatorsKpiCardsStore extends ComponentStore<ICreatorsKpiCardsState> {
  public readonly stats$ = this.selectSignal((state: ICreatorsKpiCardsState) => state.stats);
  public readonly loading$ = this.selectSignal((state: ICreatorsKpiCardsState) => state.loading);
  public readonly error$ = this.selectSignal((state: ICreatorsKpiCardsState) => state.error);

  private readonly handleError = (errorMessage: string): MonoTypeOperatorFunction<unknown> =>
    pipe(
      catchError(() => {
        this.patchState({
          error: errorMessage,
          loading: false,
        });

        return EMPTY;
      }),
    );

  public readonly fetchCreatorsStats = this.effect((trigger$: Observable<void>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ error: null, loading: true })),
      switchMap(() =>
        this.creatorsService.getCreatorsStats().pipe(
          tap((stats) => {
            this.patchState({ loading: false, stats });
          }),
          this.handleError('Failed to load creators stats'),
        ),
      ),
    );
  });

  constructor(private readonly creatorsService: CreatorsService) {
    super(initialState);
  }
}
